"use strict";

// Check if DOM is already ready
if (document.readyState === 'loading') {
	// DOM is still loading, so add event listener
	document.addEventListener('DOMContentLoaded', initClosureRedirect);
} else {
	// DOM is already ready, execute immediately
	initClosureRedirect();
}

function initClosureRedirect() {
	const automatorClosureCookie = 'automator_closure_redirect';

	const linkId = 'automator-closure-redirect';

	// Ensure client ID exists for anonymous user tracking
	ensureClientId();

	// Create a hidden campaign link
	let link = createLink(linkId);

	// Wait for the cookie from PHP
	const automatorRedirectTimeout = setInterval(checkCookie, 250);

	// Debounce timer for redirect checks
	let checkPendingTimeout = null;

	// Listen for jQuery AJAX completion (most WordPress plugins use jQuery).
	if (typeof jQuery !== 'undefined') {
		jQuery(document).on('ajaxComplete', function() {
			debouncedCheckForPendingRedirect();
		});
	}

	// Listen for native fetch and XHR completion (modern forms/apps).
	// Uses PerformanceObserver API - non-invasive, no global function overrides.
	// This works alongside any other code without conflicts.
	// NOTE: Safari/iOS often reports AJAX as "other", so jQuery detection above is critical fallback.
	if (typeof PerformanceObserver !== 'undefined' && typeof automatorClosure !== 'undefined') {
		try {
			const observer = new PerformanceObserver(function(list) {
				const entries = list.getEntries();
				for (let i = 0; i < entries.length; i++) {
					const entry = entries[i];

					// CRITICAL: Ignore our own redirect check requests to prevent infinite loop
					if (entry.name && entry.name.indexOf('automator_check_closure_redirect') !== -1) {
						continue;
					}

					// Detect fetch or XHR requests completing
					if (entry.initiatorType === 'fetch' || entry.initiatorType === 'xmlhttprequest') {
						debouncedCheckForPendingRedirect();
						break; // Only need to trigger once per batch
					}
					// Safari/iOS fallback: detect "other" requests to AJAX endpoints
					if (entry.initiatorType === 'other' && entry.name) {
						if (entry.name.indexOf('admin-ajax.php') !== -1 ||
						    entry.name.indexOf('/wp-json/') !== -1 ||
						    entry.name.indexOf('?action=') !== -1) {
							debouncedCheckForPendingRedirect();
							break;
						}
					}
				}
			});

			// Observe resource and navigation timing entries
			observer.observe({ entryTypes: ['resource', 'navigation'] });
		} catch (e) {
			// PerformanceObserver not supported or failed - jQuery + cookie polling will handle it
		}
	}

	// Debounced redirect check to prevent excessive requests
	function debouncedCheckForPendingRedirect() {
		clearTimeout(checkPendingTimeout);
		checkPendingTimeout = setTimeout(function() {
			checkForPendingRedirect();
		}, 100); // 100ms debounce
	}

	function ensureClientId() {
		// Generate or retrieve client ID for anonymous user tracking
		let clientId = localStorage.getItem('automator_client_id');

		if (!clientId || !isValidClientId(clientId)) {
			// Generate a new client ID (32-character hex string)
			clientId = generateClientId();
			localStorage.setItem('automator_client_id', clientId);
		}

		// Store in cookie so PHP can access it during AJAX requests
		// Cookie expires in 30 days to match localStorage persistence
		const date = new Date();
		date.setTime(date.getTime() + (30 * 24 * 60 * 60 * 1000));
		const expires = 'expires=' + date.toUTCString();
		document.cookie = `automator_client_id=${clientId}; ${expires}; path=/; SameSite=Lax`;
	}

	function generateClientId() {
		// Generate random 32-character hex string
		const array = new Uint8Array(16);
		crypto.getRandomValues(array);
		return Array.from(array, byte => byte.toString(16).padStart(2, '0')).join('');
	}

	function isValidClientId(id) {
		// Validate format: 32-character hex string
		return /^[a-f0-9]{32}$/.test(id);
	}

	function createLink(id) {
		const a = document.createElement('a');
		a.id = id;
		a.style.display = 'none';
		a.rel = "noopener noreferrer"; // Enhance security for external links
		document.body.appendChild(a);
		return a;
	}

	function checkCookie() {
		if (document.hidden) {
			return;
		}

		const redirectURL = getCookie(automatorClosureCookie);
		if (redirectURL && isValidUrl(redirectURL)) { // Check if the URL is valid
			clearInterval(automatorRedirectTimeout); // Stop polling once redirect is found
			deleteCookie(automatorClosureCookie);
			link.href = redirectURL;
			link.click();
		}
	}

	function isValidUrl(string) {
		// Directly accept '/' as a valid URL or start with '/' for relative URLs
		if (string === '/' || string.startsWith('/')) return true;

		try {
			new URL(string);
			return true; // The URL is valid
		} catch (_) {
			return false; // The URL is not valid
		}
	}

	function getCookie(cname) {
		const name = `${cname}=`;
		const decodedCookie = decodeURIComponent(document.cookie);
		const ca = decodedCookie.split(';');
		for (let i = 0; i < ca.length; i++) {
			let c = ca[i].trim();
			if (c.indexOf(name) === 0) {
				return c.substring(name.length);
			}
		}
		return "";
	}

	function deleteCookie(cname) {
		document.cookie = `${cname}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
	}

	function checkForPendingRedirect() {
		// Check if automatorClosure is available.
		if (typeof automatorClosure === 'undefined' || !automatorClosure.nonce) {
			return;
		}

		// Make AJAX call to check for pending redirect.
		// SECURITY: Client ID is read from cookie on server-side, NOT passed as parameter.
		// This prevents abuse where attackers could spam unique client_ids to fill wp_options.
		const ajaxUrl = automatorClosure.ajaxUrl || window.ajaxurl || '/wp-admin/admin-ajax.php';

		fetch(ajaxUrl + '?action=automator_check_closure_redirect&nonce=' + automatorClosure.nonce, {
			method: 'GET',
			credentials: 'same-origin'
		})
		.then(response => response.json())
		.then(data => {
			if (data.success && data.data.redirect_url) {
				// Set session cookie and let existing polling handle the redirect.
				document.cookie = `${automatorClosureCookie}=${data.data.redirect_url}; path=/`;
			}
		})
		.catch(error => {
			// Silently fail - this is expected if redirect terminates the request
			// or if there's no pending redirect
		});
	}
}
